import dayjs from 'dayjs';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';

const YOUR_API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;

const STATUS = process.env.REACT_APP_STATUS;
console.log(STATUS);

const handleInvalidToken = (error) => {
  Swal.fire({
    icon: 'error',
    title: 'Access Denied',
    text: `${error}. Please login again.`,
    allowOutsideClick: true,
    showConfirmButton: true,
    confirmButtonText: 'Login',
  }).then((result) => {
    if (result.isConfirmed || result.dismiss === Swal.DismissReason.backdrop) {
      localStorage.removeItem('token');
      // window.location.href = '/#/login';
    }
  });
};

const apiFunctions = {
  loginAdmin: async (UserName, Password) => {
    try {
      const response = await fetch(`${YOUR_API_ENDPOINT}/admin/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ UserName, Password }),
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error logging in:', error);
      throw new Error('Login failed');
    }
  },
  MiaMessageLogin: async (UserName, Password) => {
    const formdata = new FormData();
    formdata.append('username', UserName);
    formdata.append('password', Password);
    const requestOptions = {
      method: 'POST',
      body: formdata,
      redirect: 'follow',
    };
    try {
      const response = await fetch(
        `${YOUR_API_ENDPOINT}Register/login/access-token`,
        requestOptions
      );

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error logging in:', error);
      throw new Error('Login failed');
    }
  },
  getAllLocation: async (filter) => {
    console.log(filter);
    try {
      const response = await fetch(
        `${YOUR_API_ENDPOINT}/dashboard${filter.type}/getAllLocation?fromDate=${dayjs(
          filter.date.fromDate,
          'DD-MM_YYYY'
        ).format('YYYY-MM-DD')}&toDate=${dayjs(filter.date.toDate, 'DD-MM_YYYY').format('YYYY-MM-DD')}`,
        {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        }
      );
      if (!response.ok) {
        if (response.status === 401) {
          handleInvalidToken('Token not provided');
        } else if (response.status === 403) {
          handleInvalidToken('TInvalid token');
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'An error occurred while fetching data, please try later.',
          });
        }
      }
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching details:', error);
      throw new Error('Failed to fetch details');
    }
  },

  getGVCounts: async (filter) => {
    try {
      const url = `${YOUR_API_ENDPOINT}/dashboard${filter.type}/getGvCounts?fromDate=${dayjs(
        filter.date.fromDate,
        'DD-MM_YYYY'
      ).format('YYYY-MM-DD')}&toDate=${dayjs(filter.date.toDate, 'DD-MM_YYYY').format('YYYY-MM-DD')}`;
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      });
      if (!response.ok) {
        if (response.status === 401) {
          handleInvalidToken('Token not provided');
        } else if (response.status === 403) {
          handleInvalidToken('Invalid token');
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'An error occurred while fetching data, please try later.',
          });
        }
      }
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching GV counts:', error);
      throw new Error('Failed to fetch GV counts');
    }
  },

  getStores: async (filter) => {
    try {
      const response = await fetch(
        `${YOUR_API_ENDPOINT}/dashboard${filter.type}/getStoreDetails?fromDate=${dayjs(
          filter.date.fromDate,
          'DD-MM_YYYY'
        ).format('YYYY-MM-DD')}&toDate=${dayjs(filter.date.toDate, 'DD-MM_YYYY').format('YYYY-MM-DD')}`,
        {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        }
      );
      if (!response.ok) {
        if (response.status === 401) {
          handleInvalidToken('Token not provided');
        } else if (response.status === 403) {
          handleInvalidToken('TInvalid token');
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'An error occurred while fetching data, please try later.',
          });
        }
      }
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching store details:', error);
      throw new Error('Failed to fetch store details');
    }
  },

  getUserCounts: async (filter) => {
    try {
      const url = `${YOUR_API_ENDPOINT}/dashboard${filter.type}/getUserCounts?fromDate=${dayjs(
        filter.date.fromDate,
        'DD-MM_YYYY'
      ).format('YYYY-MM-DD')}&toDate=${dayjs(filter.date.toDate, 'DD-MM_YYYY').format('YYYY-MM-DD')}`;
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      });
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching user counts:', error);
      throw new Error('Failed to fetch user counts');
    }
  },
  getUserDetails: async (filter) => {
    try {
      // let url = `${YOUR_API_ENDPOINT}/dashboard${filter.type}/getUserDetails`;
      const url = `${YOUR_API_ENDPOINT}/dashboard${filter.type}/getUserDetails?fromDate=${dayjs(
        filter.date.fromDate,
        'DD-MM_YYYY'
      ).format('YYYY-MM-DD')}&toDate=${dayjs(filter.date.toDate, 'DD-MM_YYYY').format('YYYY-MM-DD')}`;

      const response = await fetch(url, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      });
      if (!response.ok) {
        if (response.status === 401) {
          handleInvalidToken('Token not provided');
        } else if (response.status === 403) {
          handleInvalidToken('TInvalid token');
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'An error occurred while fetching data, please try later.',
          });
        }
      }
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching user counts:', error);
      throw new Error('Failed to fetch user counts');
    }
  },

  getTopTenStoreCounts: async (filter) => {
    try {
      const response = await fetch(
        `${YOUR_API_ENDPOINT}/dashboard${filter.type}/getTopTenStoreCounts?fromDate=${dayjs(
          filter.date.fromDate,
          'DD-MM_YYYY'
        ).format('YYYY-MM-DD')}&toDate=${dayjs(filter.date.toDate, 'DD-MM_YYYY').format('YYYY-MM-DD')}`,
        {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        }
      );
      if (!response.ok) {
        if (response.status === 401) {
          handleInvalidToken('Token not provided');
        } else if (response.status === 403) {
          handleInvalidToken('TInvalid token');
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'An error occurred while fetching data, please try later.',
          });
        }
      }
      const data = await response.json();

      const formattedResponse = {};

      data.forEach(([storeID, data]) => {
        formattedResponse[storeID] = {
          storeID,
          total: data.total,
          storeCode: data.storeCode,
          storeName: data.storeName,
          locations: Object.values(data.locations),
        };
      });
      const dataArray = Object.values(formattedResponse);

      dataArray.sort((a, b) => b.total - a.total);
      return dataArray;
    } catch (error) {
      console.error('Error fetching top five store counts:', error);
      throw new Error('Failed to fetch top five store counts');
    }
  },

  getStoreCounts: async (filter) => {
    try {
      const response = await fetch(
        `${YOUR_API_ENDPOINT}/dashboard${filter.type}/getStoreCounts?fromDate=${dayjs(
          filter.date.fromDate,
          'DD-MM_YYYY'
        ).format('YYYY-MM-DD')}&toDate=${dayjs(filter.date.toDate, 'DD-MM_YYYY').format('YYYY-MM-DD')}`,
        {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        }
      );
      if (!response.ok) {
        if (response.status === 401) {
          handleInvalidToken('Token not provided');
        } else if (response.status === 403) {
          handleInvalidToken('TInvalid token');
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'An error occurred while fetching data, please try later.',
          });
        }
      }
      const data = await response.json();
      const formattedResponse = {};

      // data.forEach(([storeID, data]) => {
      //   formattedResponse[storeID] = {
      //     storeID,
      //     total: data.total,
      //     storeCode: data.storeCode,
      //     storeName: data.storeName,
      //     // locations: Object.values(data.locations),
      //   };
      // });
      const dataArray = Object.values(data);

      // dataArray.sort((a, b) => b.total - a.total);
      return dataArray;
    } catch (error) {
      console.error('Error fetching store details with counts:', error);
      throw new Error('Failed to fetch store details with counts');
    }
  },

  // LUCKY METER
  getVisitData: async (filter) => {
    try {
      const response = await fetch(
        `${YOUR_API_ENDPOINT}/luckydraw/dashboard/getVisitData?fromDate=${dayjs(
          filter.date.fromDate,
          'DD-MM_YYYY'
        ).format('YYYY-MM-DD')}&toDate=${dayjs(filter.date.toDate, 'DD-MM_YYYY').format('YYYY-MM-DD')}`,
        {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        }
      );
      if (!response.ok) {
        if (response.status === 401) {
          handleInvalidToken('Token not provided');
        } else if (response.status === 403) {
          handleInvalidToken('TInvalid token');
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'An error occurred while fetching data, please try later.',
          });
        }
      }
      const data = await response.json();
      const formattedResponse = {};
      // data.forEach(([storeID, data]) => {
      //   formattedResponse[storeID] = {
      //     storeID,
      //     total: data.total,
      //     storeCode: data.storeCode,
      //     storeName: data.storeName,
      //     // locations: Object.values(data.locations),
      //   };
      // });
      // const dataArray = Object.values(data);

      // dataArray.sort((a, b) => b.total - a.total);
      return data;
    } catch (error) {
      console.error('Error fetching store details with counts:', error);
      throw new Error('Failed to fetch store details with counts');
    }
  },

  // getUserData: async (filter) => {
  //   try {
  //     const response = await fetch(
  //       `${YOUR_API_ENDPOINT}luckydraw/dashboard/getUserData?fromDate=${dayjs(filter.date.fromDate, "DD-MM_YYYY").format("YYYY-MM-DD")}&toDate=${dayjs(filter.date.toDate, "DD-MM_YYYY").format("YYYY-MM-DD")}`,
  //       {
  //         method: 'GET',
  //         headers: {
  //           Authorization: `Bearer ${localStorage.getItem('token')}`,
  //         },
  //       }
  //     );
  //     if (!response.ok) {
  //       if (response.status === 401) {
  //         handleInvalidToken('Token not provided');
  //       } else if (response.status === 403) {
  //         handleInvalidToken('TInvalid token');
  //       } else {
  //         Swal.fire({
  //           icon: 'error',
  //           title: 'Error',
  //           text: 'An error occurred while fetching data, please try later.',
  //         });
  //       }
  //     }
  //     const data = await response.json();
  //     const formattedResponse = {};
  //     // data.forEach(([storeID, data]) => {
  //     //   formattedResponse[storeID] = {
  //     //     storeID,
  //     //     total: data.total,
  //     //     storeCode: data.storeCode,
  //     //     storeName: data.storeName,
  //     //     // locations: Object.values(data.locations),
  //     //   };
  //     // });
  //     // const dataArray = Object.values(data);

  //     // dataArray.sort((a, b) => b.total - a.total);
  //     return data;
  //   } catch (error) {
  //     console.error('Error fetching store details with counts:', error);
  //     throw new Error('Failed to fetch store details with counts');
  //   }
  // },

  getExcelData: async (filter) => {
    try {
      const response = await fetch(
        `${YOUR_API_ENDPOINT}/luckydraw/dashboard/getExcelData?fromDate=${dayjs(
          filter.date.fromDate,
          'DD-MM_YYYY'
        ).format('YYYY-MM-DD')}&toDate=${dayjs(filter.date.toDate, 'DD-MM_YYYY').format('YYYY-MM-DD')}`,
        {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        }
      );
      if (!response.ok) {
        if (response.status === 401) {
          handleInvalidToken('Token not provided');
        } else if (response.status === 403) {
          handleInvalidToken('TInvalid token');
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'An error occurred while fetching data, please try later.',
          });
        }
      }
      const data = await response.json();
      const formattedResponse = {};
      // data.forEach(([storeID, data]) => {
      //   formattedResponse[storeID] = {
      //     storeID,
      //     total: data.total,
      //     storeCode: data.storeCode,
      //     storeName: data.storeName,
      //     // locations: Object.values(data.locations),
      //   };
      // });
      const dataArray = Object.values(data);

      // dataArray.sort((a, b) => b.total - a.total);
      return dataArray;
    } catch (error) {
      console.error('Error fetching store details with counts:', error);
      throw new Error('Failed to fetch store details with counts');
    }
  },

  // -----------Message api's--------------------//
  getMessageLeaderBoard: async (filter, storeId) => {
    const accessToken = localStorage.getItem('accessToken');
    const formdata = new FormData();
    formdata.append('FromDate', dayjs(filter.date.fromDate, 'DD-MM_YYYY').format('YYYY-MM-DD'));
    formdata.append('ToDate', dayjs(filter.date.toDate, 'DD-MM_YYYY').format('YYYY-MM-DD'));
    if (storeId) {
      formdata.append('StoreId', storeId);
    }
    const requestOptions = {
      method: 'POST',
      body: formdata,
      redirect: 'follow',
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    };
    try {
      const url = `https://api-digitalmessage.coitor.com/Analytics/GetDayWiseReport/240000003`;
      const response = await fetch(url, requestOptions);
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching user counts:', error);
      throw new Error('Failed to fetch user counts');
    }
  },
  getMessageLeaderBoard2: async (filter) => {
    const accessToken = localStorage.getItem('accessToken');
    const formdata = new FormData();
    formdata.append('FromDate', dayjs(filter.date.fromDate, 'DD-MM_YYYY').format('YYYY-MM-DD'));
    formdata.append('ToDate', dayjs(filter.date.toDate, 'DD-MM_YYYY').format('YYYY-MM-DD'));
    const requestOptions = {
      method: 'POST',
      body: formdata,
      redirect: 'follow',
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    };
    try {
      const url = `https://api-digitalmessage.coitor.com/Analytics/leaderBoard_Message/240000003`;
      const response = await fetch(url, requestOptions);
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching user counts:', error);
      throw new Error('Failed to fetch user counts');
    }
  },

  getMessageAnlytics: async (filter, storeId) => {
    const accessToken = localStorage.getItem('accessToken');
    const formdata = new FormData();
    formdata.append('FromDate', dayjs(filter.date.fromDate, 'DD-MM_YYYY').format('YYYY-MM-DD'));
    formdata.append('ToDate', dayjs(filter.date.toDate, 'DD-MM_YYYY').format('YYYY-MM-DD'));
    if (storeId !== 0) {
      formdata.append('StoreId', storeId);
    }
    const requestOptions = {
      method: 'POST',
      body: formdata,
      redirect: 'follow',
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    };

    try {
      const url = `https://api-digitalmessage.coitor.com/Analytics/ShareMsgAnalytics/240000003`;
      const response = await fetch(url, requestOptions);
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching user counts:', error);
      throw new Error('Failed to fetch user counts');
    }
  },

  getAnalytics: async (filter, storeId) => {
    const accessToken = localStorage.getItem('accessToken');
    const formdata = new FormData();
    formdata.append('FromDate', dayjs(filter.date.fromDate, 'DD-MM_YYYY').format('YYYY-MM-DD'));

    formdata.append('ToDate', dayjs(filter.date.toDate, 'DD-MM_YYYY').format('YYYY-MM-DD'));
    if (storeId !== 0) {
      formdata.append('StoreId', storeId);
    }
    const requestOptions = {
      method: 'POST',
      body: formdata,
      redirect: 'follow',
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    };

    try {
      const url = `https://api-digitalmessage.coitor.com/Analytics/AnalyticsCount/240000003`;
      const response = await fetch(url, requestOptions);
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching user counts:', error);
      throw new Error('Failed to fetch user counts');
    }
  },

  getMessageCount: async (filter, StoreId) => {
    const accessToken = localStorage.getItem('accessToken');
    const formdata = new FormData();
    formdata.append('FromDate', dayjs(filter.date.fromDate, 'DD-MM_YYYY').format('YYYY-MM-DD'));
    formdata.append('ToDate', dayjs(filter.date.toDate, 'DD-MM_YYYY').format('YYYY-MM-DD'));

    if (StoreId !== 0) {
      formdata.append('StoreId', StoreId);
    }
    const requestOptions = {
      method: 'POST',
      body: formdata,
      redirect: 'follow',
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    };

    try {
      const url = `https://api-digitalmessage.coitor.com/Analytics/MessageCount/240000003`;
      const response = await fetch(url, requestOptions);
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching user counts:', error);
      throw new Error('Failed to fetch user counts');
    }
  },

  getOccasionWiseData: async (filter, storeId) => {
    const accessToken = localStorage.getItem('accessToken');
    const formdata = new FormData();
    formdata.append('FromDate', dayjs(filter.date.fromDate, 'DD-MM_YYYY').format('YYYY-MM-DD'));
    formdata.append('ToDate', dayjs(filter.date.toDate, 'DD-MM_YYYY').format('YYYY-MM-DD'));
    if (storeId !== 0) {
      formdata.append('StoreId', storeId);
    }
    const requestOptions = {
      method: 'POST',
      body: formdata,
      redirect: 'follow',
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    };

    try {
      const url = `https://api-digitalmessage.coitor.com/Analytics/OccasionWiseMessage/240000003`;
      const response = await fetch(url, requestOptions);
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching user counts:', error);
      throw new Error('Failed to fetch user counts');
    }
  },

  getMessageRating: async (filter, ratedBy, storeId) => {
    const accessToken = localStorage.getItem('accessToken');
    const formdata = new FormData();
    formdata.append('FromDate', dayjs(filter.date.fromDate, 'DD-MM_YYYY').format('YYYY-MM-DD'));
    formdata.append('ToDate', dayjs(filter.date.toDate, 'DD-MM_YYYY').format('YYYY-MM-DD'));
    formdata.append('RatedBy', ratedBy);
    if (storeId) {
      formdata.append('StoreId', storeId);
    }
    const requestOptions = {
      method: 'POST',
      body: formdata,
      redirect: 'follow',
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    };

    try {
      const url = `https://api-digitalmessage.coitor.com/Analytics/MsgRating/240000003`;
      const response = await fetch(url, requestOptions);
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching user counts:', error);
      throw new Error('Failed to fetch user counts');
    }
  },

  getListStores: async (filter, ratedBy) => {
    const accessToken = localStorage.getItem('accessToken');
    const requestOptions = {
      method: 'GET',
      // body: formdata,
      redirect: 'follow',
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    };

    try {
      const url = `https://api-digitalmessage.coitor.com/Register/ListStores`;
      const response = await fetch(url, requestOptions);
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching user counts:', error);
      throw new Error('Failed to fetch user counts');
    }
  },

  getMessageDownloadReport: async (filter, storeId) => {
    const accessToken = localStorage.getItem('accessToken');
    const formdata = new FormData();
    formdata.append('FromDate', dayjs(filter.date.fromDate, 'DD-MM_YYYY').format('YYYY-MM-DD'));
    formdata.append('ToDate', dayjs(filter.date.toDate, 'DD-MM_YYYY').format('YYYY-MM-DD'));
    if (storeId !== 0) {
      formdata.append('StoreId', storeId);
    }
    const requestOptions = {
      method: 'POST',
      body: formdata,
      redirect: 'follow',
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    };

    try {
      const url = `https://api-digitalmessage.coitor.com/Analytics/download_message_Report/240000003`;
      const response = await fetch(url, requestOptions);
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching user counts:', error);
      throw new Error('Failed to fetch user counts');
    }
  },

  getVoucherDetails: async (filter, storeId) => {
    const accessToken = localStorage.getItem('accessToken');
    const formdata = new FormData();
    formdata.append('FromDate', dayjs(filter.date.fromDate, 'DD-MM_YYYY').format('YYYY-MM-DD'));
    formdata.append('ToDate', dayjs(filter.date.toDate, 'DD-MM_YYYY').format('YYYY-MM-DD'));
    if (storeId !== 0) {
      formdata.append('StoreId', storeId);
    }
    const requestOptions = {
      method: 'POST',
      body: formdata,
      redirect: 'follow',
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    };

    try {
      const url = `https://api-digitalmessage.coitor.com/Analytics/VoucherReport/240000003`;
      const response = await fetch(url, requestOptions);
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching user counts:', error);
      throw new Error('Failed to fetch user counts');
    }
  },

  getExisitingUser: async (filter) => {
    const accessToken = localStorage.getItem('accessToken');
    const formdata = new FormData();
    formdata.append('FromDate', dayjs(filter.date.fromDate, 'DD-MM_YYYY').format('YYYY-MM-DD'));
    formdata.append('ToDate', dayjs(filter.date.toDate, 'DD-MM_YYYY').format('YYYY-MM-DD'));
    const requestOptions = {
      method: 'GET',
      // body: formdata,
      redirect: 'follow',
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    };

    try {
      const url = `${YOUR_API_ENDPOINT}/luckydraw/dashboard/getExistingUser?fromDate=${dayjs(
        filter.date.fromDate,
        'DD-MM_YYYY'
      ).format('YYYY-MM-DD')}&toDate=${dayjs(filter.date.toDate, 'DD-MM_YYYY').format('YYYY-MM-DD')}`;
      const response = await fetch(url, requestOptions);
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching user counts:', error);
      throw new Error('Failed to fetch user counts');
    }
  },

  getRedirectAnalytics: async (filter) => {
    const accessToken = localStorage.getItem('accessToken');
    const formdata = new FormData();
    formdata.append('FromDate', dayjs(filter.date.fromDate, 'DD-MM_YYYY').format('YYYY-MM-DD'));
    formdata.append('ToDate', dayjs(filter.date.toDate, 'DD-MM_YYYY').format('YYYY-MM-DD'));
    const requestOptions = {
      method: 'POST',
      body: formdata,
      redirect: 'follow',
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    };

    try {
      const url = `https://api-digitalmessage.coitor.com/Analytics/AddRedirectAnalytics/240000003`;
      const response = await fetch(url, requestOptions);
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching user counts:', error);
      throw new Error('Failed to fetch user counts');
    }
  },
};

export default apiFunctions;
